import { useQuery } from "@tanstack/react-query";
import type { CartFaqType } from "@/features/cart/types/cart-faq.type";
import { fetchStrapiFromClient } from "@/services/strapi-client";

const CART_FAQ_ENDPOINT = "/cart-faq";

export const useGetCartFaq = () => {
  return useQuery({
    queryKey: ["cart-faq"],
    queryFn: async (): Promise<CartFaqType | null> => {
      const result =
        await fetchStrapiFromClient<CartFaqType>(CART_FAQ_ENDPOINT);
      return result.data;
    },
  });
};
